import React, { FC } from "react";
import { Card } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { CustomFieldTemplateApi } from "go-segment/services/types";
import { ContactApi } from "../../../../../../../../services/Api/Organization/types";

interface Props {
	contact: ContactApi;
	customFields: CustomFieldTemplateApi[];
}

const ContactInfoCard: FC<Props> = ({ contact, customFields }) => {
	const { t } = useTranslation();

	const drawCustomFields = () => {
		const customFieldsToRender = customFields
			.map((cf) => {
				const contactCf = contact?.custom_fields?.find((x) => cf.slug === x.slug);
				if (contactCf)
					return {
						name: cf.name,
						value: contactCf.value,
					};

				return undefined;
			})
			.filter((cf) => cf?.name && cf?.value);
		return customFieldsToRender.map((cf) => `${cf?.name}: ${cf?.value}`).join(", ");
	};

	return (
		<Card className="card-box">
			<Card.Body>
				<h5 className="card-title">{t("lib:common.word.informations")}</h5>
				<div className="card-body-item">
					<div className="item-info">
						<dt>{t("common.word.custom_fields")}</dt>
						<dd>{drawCustomFields()}</dd>
					</div>
				</div>
			</Card.Body>
		</Card>
	);
};

export default ContactInfoCard;
